var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.125c-4.224 0-7.625 3.349-7.625 7.452 0 2.031 1.04 4.22 2.615 6.406 1.442 2.002 3.279 3.93 5.009 5.64 1.24-1.238 3.019-3.12 4.552-5.192.861-1.165 1.636-2.378 2.193-3.56.559-1.187.881-2.306.881-3.294 0-4.103-3.401-7.452-7.625-7.452ZM3.125 9.577C3.125 4.759 7.111.875 12 .875c4.889 0 8.875 3.884 8.875 8.702 0 1.242-.4 2.551-1 3.827-.604 1.28-1.428 2.565-2.32 3.77-1.782 2.41-3.872 4.553-5.118 5.773l-.437.428-.437-.428c-1.86-1.82-3.955-3.968-5.587-6.233-1.623-2.253-2.851-4.708-2.851-7.137ZM12 6.625a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25ZM7.625 9.75a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0Z",
    fill: "currentColor"
  })));
};
export default SvgPointer;